var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#a6a5a5",
    height: "96px",
    width: "96px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.913 301.913",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 301.913 301.913",
    transform: "rotate(45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m280.968,156.717c-6.244,0-264.634,0-272.439,0-2.638,0-5.129,1.22-6.744,3.306-1.615,2.086-2.174,4.802-1.512,7.356 5.863,22.631 30.002,39.588 58.891,39.588 25.916,0 48.006-13.649 56.511-32.797l162.201,24.209c6.028,0.9 12.149-0.871 16.766-4.85 4.617-3.979 7.272-9.772 7.272-15.866-0.001-11.569-9.378-20.946-20.946-20.946z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.707,94.947c-13,0-36.77,36.77-36.77,36.77h73.539c0,0-23.769-36.77-36.769-36.77z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoon);
export default __webpack_public_path__ + "static/media/spoon.571a345e342c7e24d5f7e2d3462d9dbd.svg";
export { ForwardRef as ReactComponent };